import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { createCheckoutSession, getMe, getPendingInvites } from "../services/api";
import "./Sidebar.css";

function Sidebar() {
  const [plan, setPlan] = useState("starter");
  const [username, setUsername] = useState("Trader");
  const [pendingCount, setPendingCount] = useState(0);
  const [loadingUpgrade, setLoadingUpgrade] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    async function loadData() {
      try {
        const me = await getMe();
        setPlan(me.plan || "starter");
        setUsername(me.username || me.email?.split("@")[0] || "Trader");
      } catch {}

      try {
        const invites = await getPendingInvites();
        setPendingCount((invites.invites || []).length);
      } catch {}
    }
    loadData();
  }, []);

  function handleNavClick() {
    setMobileOpen(false);
  }

  async function handleUpgrade() {
    try {
      setLoadingUpgrade(true);
      const data = await createCheckoutSession();
      window.location.href = data.url;
    } catch (err) {
      alert(err.message || "Failed to start checkout");
    } finally {
      setLoadingUpgrade(false);
    }
  }

  async function handleLogout() {
    try {
      await signOut(auth);
      navigate("/");
    } catch {}
  }

  const navLinks = [
    { to: "/dashboard", label: "Dashboard" },
    { to: "/calendar",  label: "Calendar"  },
    { to: "/ai-review", label: "AI Review" },
    { to: "/groups",    label: "Groups", badge: pendingCount },
    { to: "/settings",  label: "Settings"  },
  ];

  const inner = (
    <div className="sidebar-inner">
      <div className="sidebar-brand-block">
        <h2 className="logo">Tradernal</h2>
        <p className="logo-subtitle">Trading Journal with AI</p>
      </div>

      <nav>
        <ul className="sidebar-menu">
          {navLinks.map(({ to, label, badge }) => (
            <li key={to}>
              <NavLink
                to={to}
                className={({ isActive }) => isActive ? "sidebar-link active" : "sidebar-link"}
                onClick={handleNavClick}
              >
                <span>{label}</span>
                {badge > 0 && (
                  <span className="sidebar-badge">{badge}</span>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user-pill">
          <div className="sidebar-avatar">
            {username.charAt(0).toUpperCase()}
          </div>
          <div className="sidebar-user-info">
            <div className="sidebar-username-row">
              <span className="sidebar-username">{username}</span>
              {plan === "pro" && <span className="pro-badge">PRO</span>}
            </div>
            <div className="sidebar-plan-text">
              {plan === "pro" ? "Pro Member" : "Starter Plan"}
            </div>
          </div>
        </div>

        {plan !== "pro" && (
          <button
            className="primary-button"
            onClick={handleUpgrade}
            disabled={loadingUpgrade}
            style={{ width: "100%", marginTop: "12px" }}
          >
            {loadingUpgrade ? "Opening checkout…" : "Upgrade to Pro"}
          </button>
        )}

        <button
          className="secondary-button"
          onClick={handleLogout}
          style={{ width: "100%", marginTop: "10px" }}
        >
          Log Out
        </button>
      </div>
    </div>
  );

  return (
    <>
      <div className="mobile-topbar">
        <button
          className="hamburger-btn"
          onClick={() => setMobileOpen(true)}
          aria-label="Open menu"
        >
          <span /><span /><span />
        </button>
        <span className="mobile-logo">Tradernal</span>
        <div style={{ width: 44 }} />
      </div>

      {mobileOpen && (
        <div className="sidebar-backdrop" onClick={() => setMobileOpen(false)} />
      )}

      <aside className={`sidebar${mobileOpen ? " sidebar--open" : ""}`}>
        <button
          className="sidebar-close-btn"
          onClick={() => setMobileOpen(false)}
          aria-label="Close menu"
        >
          ✕
        </button>
        {inner}
      </aside>
    </>
  );
}

export default Sidebar;